export const path = {
  HOME: "/*",
  HOME__PAGE: ":page",
  LOGIN: "login",
  NHA_NGUYEN_CAN: "nha-nguyen-can",
  CAN_HO_MINI: "can-ho-mini",
  CAN_HO_DICH_VU: "can-ho-dich-vu",
  CAN_HO_CHUNG_CU: "can-ho-chung-cu",
  SEARCH: "tim-kiem",
  SYSTEM: "/he-thong/*",
  CREATE_POST: "tao-moi-bai-dang",
  MANAGE_POST: "quan-ly-bai-dang",
  EDIT_ACCOUNT: "sua-thong-tin-ca-nhan",
  CONTACT: "lien-he",
  DETAIL_POST_TITLE_POSTID: "chi-tiet/:title/:postId",
  DETAIL: "/chi-tiet/",
  DETAIL_ALL: "chi-tiet/*",
};

export const text = {
  HOME_TITLE: "Kênh thông tin Phòng Trọ số 1 Việt Nam",
  HOME_DESCRIPTION:
    "Kênh thông tin Phòng Trọ số 1 Việt Nam - Website dăng tin cho thuê phòng trọ, nhà nguyên căn, căn hộ, ở ghép nhanh, hiệu quả với  100.000+ tin đăng 2.500.000 lượt xem mỗi tháng.",
};

export const location = [
  {
    id: "hcm",
    name: "Phòng trọ Hồ Chí Minh",
    image:
      "https://tragodi.com/wp-content/uploads/2024/02/ho-chi-minh-city.jpg",
    provinceCode: "CHMN",
  },
  {
    id: "hn",
    name: "Phòng trọ Hà Nội",
    image: "https://asiatravel.net.vn/upload/images/tbl_news_1740110995.jpg",
    provinceCode: "NNIT",
  },
  {
    id: "vt",
    name: "Phòng trọ Vũng Tàu",
    image:
      "https://homaypark.com/wp-content/uploads/2025/06/kham-pha-ve-dep-tuyet-voi-cua-du-lich-vung-tau-trai-nghiem-nang-cao-voi-nhung-diem-den-khong-the-bo-qua-68502b016586b.jpg",
    provinceCode: "RUVO",
  },
];
